export enum USER_VISIBILITY_PERMISSIONS {
  btn_create_segnalazioni = 'btn_create_segnalazioni',
  btn_read_segnalazioni = 'btn_read_segnalazioni',
  btn_vediStruttura = 'btn_vediStruttura',
  btn_avanzamento = 'btn_avanzamento',
  btn_create_esami_obiettivi = 'btn_create_esami_obiettivi',
  btn_read_esami_obiettivi = 'btn_read_esami_obiettivi',
  btn_create_diagnosi = 'btn_create_diagnosi',
  btn_read_diagnosi = 'btn_read_diagnosi',
  btn_create_valutazione = 'btn_create_valutazione',
  btn_read_valutazione = 'btn_read_valutazione',
  btn_create_terapia = 'btn_create_terapia',
  btn_read_terapia = 'btn_read_terapia',
  btn_create_piano_di_cura = 'btn_create_piano_di_cura',
  btn_create_allergie = 'btn_create_allergie',
  btn_delete_allergie = 'btn_delete_allergie',
  btn_update_allergie = 'btn_update_allergie',
  btn_update_anagrafica = 'btn_update_anagrafica',
  btn_update_note = 'btn_update_note',
  btn_create_note = 'btn_create_note',
  btn_read_note = 'btn_read_note',
  btn_create_anamnesi = 'btn_create_anamnesi',
  btn_read_anamnesi = 'btn_read_anamnesi',
  btn_create_diario_clinico = 'btn_create_diario_clinico',
  btn_read_diario_clinico = 'btn_read_diario_clinico',
  btn_update_diario_clinico = 'btn_update_diario_clinico',
  btn_delete_diario_clinico = 'btn_delete_diario_clinico',
  btn_create_referto = 'btn_create_referto',
  btn_read_referto = 'btn_read_referto',
  btn_create_presenze = 'btn_create_presenze',
  btn_read_allergie = 'btn_read_allergie',
  btn_read_appuntamenti = 'btn_read_appuntamenti',
  btn_delete_appuntamenti = 'btn_delete_appuntamenti',
  btn_read_cct = 'btn_read_cct',
  btn_read_diario = 'btn_read_diario',
  btn_read_documenti = 'btn_read_documenti',
  btn_read_notifiche = 'btn_read_notifiche',
  btn_read_pai = 'btn_read_pai',
  btn_create_pai = 'btn_create_pai',
  btn_read_parametri = 'btn_read_parametri',
  btn_read_paziente = 'btn_read_paziente',
  btn_read_piano_di_cura = 'btn_read_piano_di_cura',
  btn_read_pic = 'btn_read_pic',
  btn_read_presenze_apic = 'btn_read_presenze_apic',
  btn_read_prestazioni_pic = 'btn_read_prestazioni_pic',
  btn_read_referenti = 'btn_read_referenti',
  btn_read_scale_paziente = 'btn_read_scale_paziente',
  btn_read_segnalazioni_tags = 'btn_read_segnalazioni_tags',
  btn_create_turno = 'btn_create_turno',
  btn_trasferimento_temp = 'btn_trasferimento_temp',
  btn_read_prescrizioni = 'btn_read_prescrizioni',
  btn_create_collaboratori = 'btn_create_collaboratori',
  edit_dashboard = 'edit_dashboard',
}
